import React from 'react'
import Map from './Map';
const NgoData =() => {

  return (
    <div>
     <Map containerElement={<div style={{ height: '500px' }} />}
     mapElement={<div style={{ height: '500px' }} />}
    />
    </div>
   
  )
}

export default NgoData
